<template>
    <div>
        <div class="modal is-active" @click.stop="closeModal">
            <div class="modal-background"></div>
            <div class="modal-content">
                <div class="tile is-ancestor ">
                    <div class="tile is-8 is-centered has-limited-width-600">
                        <article class="tile is-child is-12">
                            <div @click.stop class="object-view">
                                <header class="modal-card-head is-block">
                                    <div class="level is-mobile">
                                        <div class="level-left">
                                            <div class="level-item">
                                                <p class="
                                                        title
                                                        is-size-4
                                                        has-text-weight-normal	
                                                    " :title="getName(content)">
                                                    {{ getName(content) }}
                                                </p>
                                            </div>
                                            
                                        </div>
                                        <div class="level-right">
                                            <div class="level-right">
                                                <div class="navbar-item has-dropdown is-hoverable" v-if="isMultilang">
                                                    <a class="navbar-link is-arrowless mr-4" style="text-transform: capitalize;">
                                                        <!--<span class="icon"><i class="mdi mdi-28px mdi-web"></i></span>-->
                                                        {{ langLabel(activeLang) }}
                                                    </a>

                                                    <div class="navbar-dropdown">
                                                        <a
                                                            v-for="lang in languages"
                                                            :key="lang"
                                                            @click="activeLang = lang"
                                                            class="navbar-item"
                                                            style="text-transform: capitalize;"
                                                        >
                                                            {{ langLabel(lang) }}
                                                        </a>
                                                    
                                                    </div>
                                                </div>
                                                <a v-if="canEdit && !viewMode" class="level-item" @click="editObject">
                                                    <figure class="image is-28x28">
                                                        <img src="@/assets/images/icon_edit.svg">
                                                    </figure>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </header>
                                <section class="modal-card-body pt-0 pb-5">
                                    <!--<hr />-->
                                    
                                    <ObjectGallery v-if="content.images" :images="content.images" :showing="true"
                                        class="mb-4" @zoomImage="zoomImage"/>
                                    <object-card-tags v-if="content.tags" :tags="content.tags" class="mb-4" />
                                    <p class="content mb-4" v-html="getDescription" />
                                     <div v-if="isMultilang">
                                         <div  v-if="hasVideo">
                                            <div v-for="langCode in $store.getters.project.langs" :key="langCode" class="lang-field" :class="{'is-active':activeLang==langCode}">
                                               <ObjectVideo :video="getVideo(langCode)" class="mb-4" />
                                            </div>
                                         </div>
                                    </div>
                                    <div v-else>
                                        <ObjectVideo v-if="content.video" :video="content.video" class="mb-4" />
                                    </div>
                                    <div v-if="isMultilang">
                                         <div class="audio-player mb-4" v-if="hasAudio">
                                            <div v-for="langCode in $store.getters.project.langs" :key="langCode" class="lang-field" :class="{'is-active':activeLang==langCode}">
                                                <ObjectAudio :audio="getAudio(langCode)" />
                                            </div>
                                         </div>
                                    </div>
                                    <div v-else>
                                        <div class="audio-player mb-4" v-if="content.audio">
                                            <ObjectAudio :audio="content.audio" />
                                        </div>
                                    </div>

                                    <ObjectEmbed v-if="content.embed" :embed="content.embed" class="mb-4 px-0 py-0" />

                                    <div v-if="isMultilang">
                                        <div class="links-zone mb-4 px-0 py-0" v-if="hasUrl">
                                            <div v-for="langCode in $store.getters.project.langs" :key="langCode" class="lang-field" :class="{'is-active':activeLang==langCode}">
                                                <ObjectURL  :url="getUrl(langCode)" class="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="links-zone mb-4 px-0 py-0">
                                        <ObjectURL v-if="content.url" :url="content.url" class="" />
                                    </div>

                                    <div class="files-zone mb-4 px-0 py-0">
                                        <ObjectFiles v-if="content.files &&
                                            content.files.length
                                            " :files="content.files" class="" />
                                    </div>
                                     <div v-if="content.questions.length">
                                        <p class="title is-size-5 has-text-weight-normal has-text-centered">
                                            {{ $t("this_object_contains") }}
                                            <span class=""> {{ content.questions.length }}</span>
                                            <span class="is-lowercase" v-if="content.questions.length>1"> {{ $t("Sessions.questions") }}</span>
                                            <span class="is-lowercase" v-else> {{ $t("Sessions.question") }}</span>
                                        </p>
                                        
                                    </div>

                                </section>
                                


                            </div>
                        </article>
                        <!--<transition
                            enter-active-class="animated slideInLeft"
                            leave-active-class="animated slideOutLeft"
                            mode="out-in"
                        >-->
                        <article class="tile is-child comments-zone is-9" v-if="showComments">

                            <n-object-card-comments v-if="isLoggedIn && canAddComment" :comments="content.comments"
                                :object="content" :showTitle="true" :render-all="showAllComments"
                                :creationDisabled="viewMode" class="lb-modal-comments"
                                @loadOldComments="showAllComments = true" />
                        </article>
                        <!--</transition>-->
                    </div>
                </div>
            </div>
        </div>
        <project-modal-share v-if="showShareModal" :content="content" @close="showShareModal = false" />
    </div>
</template>

<script>
import { likeObject } from '@/services/API';
import { isEmpty } from 'underscore';
import UserMiniProfile from '@/components/UserMiniProfile';
import AppModalView from '@/components/AppModalView';
import NObjectCardComments from '@/components/NObjectCardComments';
import ProjectModalShare from '@/components/ProjectModalShare';
import ObjectGallery from '@/components/ObjectGallery';
import ObjectVideo from '@/components/ObjectVideo';
import ObjectAudio from '@/components/ObjectAudio';
import ObjectEmbed from '@/components/ObjectEmbed';
import ObjectStaticMap from '@/components/ObjectStaticMap';
import ObjectFiles from '@/components/ObjectFiles';
import ObjectURL from '@/components/ObjectURL';
import ObjectCardTags from '@/components/ObjectCardTags';
import { VueAgile } from 'vue-agile'
import _ from 'underscore';
export default {
    components: {
        UserMiniProfile,
        AppModalView,
        NObjectCardComments,
        ProjectModalShare,
        ObjectGallery,
        ObjectVideo,
        ObjectAudio,
        ObjectEmbed,
        ObjectStaticMap,
        ObjectFiles,
        ObjectURL,
        ObjectCardTags,
        agile: VueAgile,
    },
    props: {
        object: { type: Object, default: {} },
        viewMode: { type: Boolean, default: true },
    },
    data: function () {
        return {
            showShareModal: false,
            showAllComments: true,
            showComments: false,
            activeLang: ''
        };
    },
    computed: {
        content() {
            return this.object;
        },
        contentURL() {
            return window.location.href;
        },
        isMap() {
            return 'map' === this.$store.getters.project.mode;
        },
        locationIsEmpty() {
            return isEmpty(this.content.location);
        },
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        canAddComment() {

            if (this.isLoggedIn && this.$store.getters.canCommentInObjects) {
                return true;
            }
            return false;
        },
        canEdit() {
            if (this.content.accessLevel) {
                return this.content.accessLevel != 'read';
            } else {
                return false;
            }
        },
        languages() {
            return this.$store.getters.project.langs;
        },
        isMultilang() {
            return this.$store.getters.project.langs && this.$store.getters.project.langs.length > 0;  
        },
        defaultLang() {
            return this.$store.getters.project.defaultLang;
        },
        hasAudio() {
            if (this.isMultilang && (this.content.audioPerLang && !_.isEmpty(this.content.audioPerLang))) {
                return true;
            }
            return false;
        },
        hasVideo() {
            if (this.isMultilang && (this.content.videoPerLang && !_.isEmpty(this.content.videoPerLang))) {
                
                return true;
            }
            return false;
        },
        hasUrl() {
            if (this.isMultilang && (this.content.urlPerLang && !_.isEmpty(this.content.urlPerLang))) {
                return true;
            }
            return false;
        },
        hasFiles() {
            if (this.isMultilang && this.content.filesPerLang && !_.isEmpty(this.content.filesPerLang)) {
                return true;
            }
            return false;
        },
        getDescription() {
            if (this.isMultilang) {
                let locale = this.$i18n.locale;
                if (locale == 'ca-ES') {
                    locale = "ca";
                }
                const defaultLang = this.$store.getters.project.defaultLang;
                // console.log("desc locale", locale)
                if (this.content.descriptionPerLang && this.content.descriptionPerLang[this.activeLang]) {
                    return this.content.descriptionPerLang[this.activeLang];
                }  else if (defaultLang && this.content.descriptionPerLang && this.content.descriptionPerLang[defaultLang]) {
                    // console.log("desc returning default")
                    return this.content.descriptionPerLang[defaultLang]
                } else if (this.content.descriptionPerLang && this.content.descriptionPerLang[locale]) {
                    // console.log("desc returning locale")
                    return this.content.descriptionPerLang[locale]
                }
                // console.log("no desc")
            } else {
                return this.content.description;
            }
        }
        
    },
    methods: {
        closeModal() {
            /* this.$router.replace({
                name: this.$route.meta.embed ? 'embed-project' : 'project',
                params: { projectId: this.$store.getters.project._id },
                query: this.$route.query,
            });
            */
            this.$emit('close');
        },
        editObject() {
            /* this.$router.replace({
                name: this.$route.meta.embed ? 'embed-project' : 'project',
                params: {
                    projectId: this.$store.getters.project._id,
                    edit: true,
                    object: this.$route.params.objectId,
                },
                query: this.$route.query,
            });*/
            // console.log('go to edit');
            this.$emit('edit-object');
        },
        async toggleLike() {
            let likeResult = await likeObject(this.content._id);
            // console.log({ likeResult });
        },
        zoomImage(e){
            this.$emit('zoomImage',e);
        },
        langLabel(lang) {
            return this.$t("LANG_" + lang);
        },
        getName(item) {
            if (this.isMultilang) {
                let locale = this.$i18n.locale;
                if (locale == 'ca-ES') {
                    locale = "ca";
                }
                const defaultLang = this.$store.getters.project.defaultLang;
                // console.log("locale", locale)
                if (item.titlePerLang && item.titlePerLang[this.activeLang]) {
                    return item.titlePerLang[this.activeLang];
                }  else if (defaultLang && item.titlePerLang && item.titlePerLang[defaultLang]) {
                    // console.log("returning default")
                    return item.titlePerLang[defaultLang]
                } else if (item.titlePerLang && item.titlePerLang[locale]) {
                    // console.log("returning locale")
                    return item.titlePerLang[locale]
                }else {
                    // console.log("returning standar")
                    return item.title;
                }
                
            } else {
                return item.title;
            }
            
        },
        getAudio(lang) {
            if (this.content.audioPerLang && this.content.audioPerLang[lang]) {
                // console.log("audio correct lang")
                return this.content.audioPerLang[lang];
            } else if (this.content.audioPerLang && this.content.audioPerLang[this.defaultLang]) {
                // console.log("audio defaultLang")
                return this.content.audioPerLang[this.defaultLang]
            }
        },
        getVideo(lang) {
            if (this.content.videoPerLang && this.content.videoPerLang[lang]) {
                // console.log("video correct lang")
                return this.content.videoPerLang[lang];
            } else if (this.content.videoPerLang && this.content.videoPerLang[this.defaultLang]) {
                // console.log("video defaultLang")
                return this.content.videoPerLang[this.defaultLang]
            }
        },
        getUrl(lang) {
            if (this.content.urlPerLang && this.content.urlPerLang[lang]) {
                // console.log("video correct lang")
                // console.log(this.content.urlPerLang[lang])
                return this.content.urlPerLang[lang];
            } else if (this.content.urlPerLang && this.content.urlPerLang[this.defaultLang]) {
                // console.log("video defaultLang")
                // console.log(this.content.urlPerLang[this.defaultLang])
                return this.content.urlPerLang[this.defaultLang]
            }
        },
        getFiles(lang) {
            if (this.content.filesPerLang && this.content.filesPerLang[lang]) {
                // console.log("video correct lang")
                return this.content.filesPerLang[lang];
            } else if (this.content.filesPerLang && this.content.filesPerLang[this.defaultLang]) {
                // console.log("video defaultLang")
                return this.content.filesPerLang[this.defaultLang]
            }
        },
    },
    mounted: function () {
        // console.log("mounted")
        // console.log(this.viewMode,this.content)
        if (this.isMultilang) {
            // console.log("setting activeLang")
            let locale = this.$i18n.locale;
            if (locale == 'ca-ES') {
                locale = "ca";
            }
            // console.log(locale,this.$store.getters.project.langs.includes(locale))
            if (this.$store.getters.project.langs.includes(locale)) {
                this.activeLang = locale;
            } else {
                this.activeLang = this.$store.getters.project.defaultLang;
            }
            // console.log("setting activeLang setted to",this.activeLang)
        }
    }
};
</script>

<style scoped>
@import '../assets/css/object-view.css';

.lang-field{
    display: none;
}
.lang-field.is-active{
    display: block;
}
</style>
